import { Logo } from "../../components/logo";
import { ConfirmPassForm } from "../../components/forms/auth";

export const RecoveryPass = () => {
  return (
    <div className="w-full flex items-center justify-center min-h-screen">
      <div className="flex flex-col gap-y-8 items-center px-6 md:px-0">
        <Logo
          className="justify-self-end w-32"
          align="vertical"
          width="128px"
        />
        <div className="max-w-[592px] text-center flex flex-col gap-y-8 pt-8 pb-16">
          <div className="text-5xl font-poppins font-bold theme-text-default">
            Change password
          </div>
          <div className="text-gray-300">
            In order to secure your account, make sure your password is at least
            8 characters and symbols.
          </div>
        </div>
        <ConfirmPassForm />
      </div>
    </div>
  );
};
